import { RouterView } from "vue-router";

import Route from "@/router/Route";
import CurvesOverview from "@/modules/booking_experts/pages/CurvesOverview.vue";
import Base from "@/modules/booking_experts/pages/Base.vue";
import PricelistOverview from "@/modules/booking_experts/pages/PricelistOverview.vue";
import OffsetCurveEditOverview from "@/modules/booking_experts/pages/OffsetCurveEditOverview.vue";
import YearEditOverview from "@/modules/booking_experts/pages/YearEditOverview.vue";
import BookingsOverview from "@/modules/booking_experts/pages/BookingsOverview.vue";
import PricingHistoryOverview from "@/modules/booking_experts/pages/PricingHistoryOverview.vue";
import PriceListImportsOverview from "@/modules/booking_experts/pages/PriceListImportsOverview.vue";

export default new Route(
	"pricing",
	"/pricing",
	Base,
	[
		new Route(
			"pricing.view",
			"pricelists",
			RouterView,
			[new Route("pricing.list", "", PricelistOverview, [], {})],
			{}
		),

		new Route("bookings.overview", "bookings", BookingsOverview, [], {}),

		// Price curve creator / editor
		new Route(
			"pricing.curves-base",
			"curves",
			RouterView,
			[
				new Route("pricing.curves", "", CurvesOverview, [], {}),
				new Route("pricing.curve.edit", ":id", OffsetCurveEditOverview, [], {}),
			],
			{}
		),

		new Route("pricing.apply-batch", "apply/batch", YearEditOverview, [], {
			permissions: ["can_use_batch_curve_assignment"],
		}),

		// Price application creator / editor
		new Route(
			"pricing.year",
			"apply",
			RouterView,
			[new Route("pricing.apply", ":id", YearEditOverview, [], {})],
			{}
		),

		new Route(
			"history",
			"history",
			RouterView,
			[new Route("history.overview", ":id", PricingHistoryOverview, [], {})],
			{}
		),

		// Price imports of one source price list. The :importId variant opens that
		// run's details dialog, so a progress toast can link straight to it.
		new Route(
			"pricing.imports-base",
			"imports",
			RouterView,
			[
				new Route("pricing.imports", ":id", PriceListImportsOverview, [], {
					permissions: ["can_manage_booking_experts"],
				}),
				new Route(
					"pricing.imports.view",
					":id/:importId",
					PriceListImportsOverview,
					[],
					{ permissions: ["can_manage_booking_experts"] }
				),
			],
			{}
		),
	],
	{},
	(): string => {
		return `/pricing/pricelists`;
	}
);
